export default "__VITE_ASSET__D1tl027Q__"